jQuery($ => {
  class PageNavItem {
    constructor(element) {
      this._        = element;
      this._element = $(element);
      this._element = $(element);
      this._subList = this._element.find('.m-page-nav__sub-list');
      this._link    = this._element.find('.m-page-nav__link');
      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger( 'init', this );
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      if (this._subList?.length) {
        this._element.on('mouseenter', this.handleMouseEnter);
        this._element.on('mouseleave', this.handleMouseLeave);
        this._element.on('click',      this.handleItemClick);
        this._link.on('click',         this.handleLinkClick);
      }
    }

    handleMouseEnter = (event) => {
      var windowWidth = $(window).width();
      if (windowWidth > 950) {
        this.handleShowSubList(event);
      }
    }

    handleMouseLeave = (event) => {
      this.handleHideSubList(event);
    }

    handleLinkClick = (event) => {
      event.stopPropagation();
    }

    handleItemClick = () => {
      if (this._subList.hasClass('m-page-nav__sub-list--open')) {
        this.handleHideSubList();
      } else {
        this.handleShowSubList();
      }
    }

    handleShowSubList = (event) => {
      this._subList.addClass('m-page-nav__sub-list--open');
      this._element.addClass('m-page-nav__item--open');
    }

    handleHideSubList = () => {
      this._subList.removeClass('m-page-nav__sub-list--open');
      this._element.removeClass('m-page-nav__item--open');
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.page_nav_item = function() {
    var _ = this,
        opt = arguments[0],
        args = Array.prototype.slice.call(arguments, 1),
        l = _.length,
        i,
        ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].page_nav = new PageNavItem(_[i], opt);
      else
        ret = _[i].page_nav[opt].apply(_[i].page_nav, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.m-page-nav__item').page_nav_item();
});